import { createApp } from 'vue';
import { createPinia } from 'pinia';
import dayjs from 'dayjs';
import * as Sentry from "@sentry/vue";

import App from './App.vue';
import router from './router';

import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';

dayjs.extend(relativeTime);
dayjs.extend(duration);

const pinia = createPinia();
const app = createApp(App);

if (import.meta.env.PROD) {
    console.info('Sentry enabled');

    Sentry.init({
        app,
        dsn: "https://ed80801e14ea085d0e3622e6a76b3465@o4508905051848704.ingest.us.sentry.io/4508905082060800",
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration(),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
            "localhost", 
            "c.carhero.net", 
            // test production build on local
            "console.carhero.net", 
            // production
            "console.carheroph.app"
        ],
        // Session Replay
        //replaysSessionSampleRate: 0.4, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        //replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        environment: 'production',
    });
}

app.use(pinia);
app.use(router);

import './assets/main.css';
import 'ant-design-vue/dist/reset.css';

app.mount('#app');